import { Table as TableAntd } from 'antd';
import styled from 'styled-components';

export const Table = styled(TableAntd)`
  .ant-table.ant-table-small .ant-table-title,
  .ant-table.ant-table-small .ant-table-footer,
  .ant-table.ant-table-small .ant-table-thead > tr > th,
  .ant-table.ant-table-small .ant-table-tbody > tr > td,
  .ant-table.ant-table-small tfoot > tr > th,
  .ant-table.ant-table-small tfoot > tr > td {
    padding: 2px 8px;
  }
  .ant-table-cell .ant-row button {
    margin: 0.25em 0px 0.25em 0px;
  }
`;
